const Modal = {
  baseStyle: {
    header: {
      padding: '24px',
    },
    dialog: {
      borderRadius: 'base',
      boxShadow: 'modal',
      maxW: '100%',
    },

    closeButton: {
      w: '36px',
      h: '36px',
      color: 'secondary.400',
      top: '24px',
      right: '24px',
    },
    body: {
      p: '24px',
      textAlign: 'center',
    },
    footer: {
      p: '0 24px 24px',
    },
  },
  sizes: {
    md: {
      dialog: {
        w: '424px',
      },
    },

    lg: {
      dialog: {
        maxW: '872px',
      },
    },
  },
  defaultProps: {
    header: {
      textStyle: 'h5',
    },
  },
};

export default Modal;
